import 'stylesheets/pages/event/infographics/style';

import Infographics from 'modules/views/Event/Infographics/Index.vue';

new Vue({
  // components: {
  //   Infographics,
  // },
  render: (h) => h(Infographics),
}).$mount('#app');
